import { Button, Image, message, Modal, notification, Popover, Progress, Radio, Select, Space, Table, Upload } from "antd"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import Utils from "@utils/utils"
import styles from "./index.module.scss"
import API, { commonApiInvoker } from "@api/api";
import { useDrag, useDrop, useDragLayer } from 'react-dnd';
import { MinusCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import XLSX from "xlsx";
import JSZip from 'jszip';
// const {parseStringPromise} = require('xml2js')
import {parseStringPromise} from "xml2js"
const ExcelJS = require('exceljs');
const _ = require('lodash')
const GOODS_TYPE = {
    CONSIGNMENT: "consignment", // 寄拍
    NON_CONSIGNMENT: "non_consignment" // 普通
}

const ExcelBatchAdd = (props) => {
    const {
        // merchantId,
        // merchantName,
        goodsType=GOODS_TYPE.NON_CONSIGNMENT, // GOODS_TYPE.NON_CONSIGNMENT-普通商品; GOODS_TYPE.CONSIGNMENT-寄拍商品
        onOk,
        onCancel,
    } = props
    const [modal, modalContextHolder] = Modal.useModal();
    const [api, contextHolder] = notification.useNotification();
    const deliveryVersionRef = useRef() // 交付批次   
    // const [dataSource, setDataSource] = useState(sessionStorage.getItem('skuList') ? JSON.parse(sessionStorage.getItem('skuList')) : [])
    const [dataSource, setDataSource] = useState([])
    const [loading, setLoading] = useState(false)
    const [uploading, setUploading] = useState(false)
    const uploadAbort = useRef()
    const [uploadTotal, setUploadTotal] = useState(0)
    const [uploadSuccess, setUploadSuccess] = useState(0)
    const uploadProgress = useMemo(() => {
        if (uploadTotal == 0) return 0
        return Math.floor(uploadSuccess / uploadTotal * 100)
    }, [uploadTotal, uploadSuccess])
    useEffect(() => {
        return () => {
            uploadAbort.current?.abort()
        }
    }, [])

    // 相同skucode数据合并
    const displayDataSource = useMemo(() => {
        return dataSource
    }, [dataSource])

    // 处理字符串
    const filterString = (str) => {
        str = str.toString()
        return Utils.sanitizeString(str)
    }
    const appendSkuCode = (item) => {
        const {uid, index, id, deliveryVersion,skuCode,imageCount=1} = item
        if (!deliveryVersionRef.current) deliveryVersionRef.current = deliveryVersion
        setDataSource(pre => {
            const temp = [...pre]
            temp.push({
                uid,
                index,
                id,
                skuCode,
                deliveryVersion,
                imageCount,
                skuImages: [], // 源素材
                matchImages: [], // 搭配图
                refImages: [], // 参考图
            })
            return [...temp]
        })
    }

    const appendImage = (item) => {
        const {uid, index, id, deliveryVersion,isSkuImages,isRefImages,isMatchImages,name,skuCode,url,imageCount=1} = item
        setDataSource(pre => {
            const temp = [...pre]
            const skuItem = temp.find(item => item.index == index)
            if (skuItem) {
                if (isSkuImages) skuItem.skuImages = [...skuItem.skuImages, {url, name}]
                if (isMatchImages) skuItem.matchImages = [...skuItem.matchImages, {url, name}]
                if (isRefImages) skuItem.refImages = [...skuItem.refImages, {url, name}]
            } else {
                const skuItem = {
                    uid,
                    index,
                    id,
                    skuCode,
                    deliveryVersion,
                    imageCount,
                    skuImages: isSkuImages ? [{url, name}] : [], // 源素材
                    matchImages: isMatchImages ? [{url, name}] : [], // 搭配图
                    refImages: isRefImages ? [{url, name}] : [], // 参考图
                }
                temp.push(skuItem)
            }
            if (temp.length == 0) deliveryVersionRef.current = null
            else if (!deliveryVersionRef.current) deliveryVersionRef.current = deliveryVersion
            return [...temp]
        })
    }
    // 上传excel
    const handleUpload = async (file) => {
        console.log('file', file)
        try {
            if (
                file.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || 
                !file.name.toLowerCase().endsWith('.xlsx')
            ) throw new Error("请上传正确的xlsx文件")
            uploadAbort.current = new AbortController();
            setUploadSuccess(0)
            setUploadTotal(0)
            setUploading(true)
            const data = await readExcel(file)
            const workbook = new ExcelJS.Workbook();
            try {
                await workbook.xlsx.load(data);
            } catch (err) {
                console.log(err)
                message.error(`加载excel失败，请上传正确的excel 【${err.message}】`)
                return
            }
            const imageResult = await parseWPSEmbedMedia(data, workbook)
            // 仅解析第一个sheet的内容
            const worksheet = workbook.getWorksheet();
            // 交付批次：第一个sheet名
            const deliveryVersion = worksheet.name
            // if (deliveryVersionRef.current) {
            //     if (deliveryVersionRef.current !== deliveryVersion) {
            //         throw new Error("前后批次（一级目录）不一致，请修改后上传！")
            //     }
            // }
            // 默认从第7行开始解析，第5行为字段名
            const maxRow = getMaxDataRowNumber(worksheet)
            const allRows = worksheet.getRows(7, maxRow - 6);
            // console.log('imageResult', imageResult)
            // console.log('workbook', workbook)
            // console.log('worksheet', worksheet)
            if (!allRows) throw new Error("表格内容为空，请核对后重新上传")
            // 第5行为字段名
            const headRow = worksheet.getRow(5)
            // 商品货号 {序号}_{主拍品货号}-{颜色}_{搭配品货号}
            //  - 忽略主拍品货号、颜色、搭配品货号字段中的空格、特殊字符（：/\[]{}《》<>-_等）
            //  - 字段中有换行，默认用“_”拼接
            //  - “源素材”的图片文件命名也为该货号
            //  - 若录入的商品货号已存在该商家中，报错提示并跳过录入
            //  - 序号、主拍品货号、颜色、搭配品货号均允许为空，允许换行
            //     - 序号、主拍品货号、颜色、搭配品货号任何字段为空/不存在，直接跳过
            //     - 序号、主拍品货号、颜色、搭配品货号所有字段为空，该商品货号为空
            //  - 某行录入格式错误或者录入失败，需提示失败原因
            //     - "源素材"字段缺失：“源素材列字段名称有误，请核对后重新上传”
            //     - "源素材"图为空：“第{行号}行图片为空，请补充后重新上传”
            //     - 字段名包含“源素材”的值非图片：“第{行号}行“源素材_{n}”格式错误，请补充后重新上传”
            //     - 若录入的商品货号已存在该商家中：“该商品已存在”
            const skuImageIndexs = []
            const matchImageIndexs = []
            const refImageIndexs = []
            let idIndex, // 序号
                mainSkuCodeIndex, // 主拍品货号
                colorIndex, // 颜色
                imageCountIndex, // 需求张数
                matchSkuCodeIndex, // 搭配品货号
                remarkIndex // 备注
            for (let index = 1; index <= headRow.cellCount; index++) {
                const value = headRow.getCell(index).value
                // 序号
                if (/序号/.test(value)) idIndex = { index, value, }
                // 主拍品货号
                if (/主拍品货号/.test(value)) mainSkuCodeIndex = { index, value, }
                // 颜色
                if (/颜色/.test(value)) colorIndex = { index, value, }
                // 需求张数
                if (/需求张数/.test(value)) imageCountIndex = { index, value, }
                // 搭配品货号
                if (/搭配品货号/.test(value)) matchSkuCodeIndex = { index, value, }
                // 备注
                if (/备注/.test(value)) remarkIndex = { index, value, }
                // 源素材：字段名包含"源素材"，解析值为源素材图片
                if (/源素材/.test(value)) skuImageIndexs.push({ index, value, })
                // 搭配图：字段名包含"搭配图"，解析值为搭配图图片
                if (/搭配图/.test(value)) matchImageIndexs.push({ index, value, })
                // 参考图：字段名包含"参考图"，解析值为参考图图片
                if (/参考图/.test(value)) refImageIndexs.push({ index, value, })
            }
            if (skuImageIndexs.length == 0) throw new Error("源素材列字段名称有误，请核对后重新上传")
                
            // 清空数据
            setDataSource([])
            
            setUploadTotal(allRows.length)
            const errorList = []
            for (let index = 0; index < allRows.length; index++) {
                // 中止上传
                if (uploadAbort.current?.signal.aborted) return
                const row = allRows[index]
                // 序号
                const id = idIndex ? row.getCell(idIndex.index).value : ""
                // 主拍品货号
                const mainSkuCode = mainSkuCodeIndex ? row.getCell(mainSkuCodeIndex.index).value : ""
                // 颜色
                const color = colorIndex ? row.getCell(colorIndex.index).value : ""
                // 需求张数
                let imageCount = imageCountIndex ? row.getCell(imageCountIndex.index).value : "1"
                // 搭配品货号
                const matchSkuCode = matchSkuCodeIndex ? row.getCell(matchSkuCodeIndex.index).value : ""
                // 备注
                const remark = remarkIndex ? row.getCell(remarkIndex.index).value : ""
                // 货号 {序号}_{主拍品货号}-{颜色}_{搭配品货号}
                let skuCode = ""
                let arr = []
                if (id && filterString(id)) arr.push(filterString(id))
                if (mainSkuCode && filterString(mainSkuCode)) arr.push(filterString(mainSkuCode))
                arr = arr.join("_") ? [arr.join("_")] : []
                if (color && filterString(color)) arr.push(filterString(color))
                arr = arr.join("-") ? [arr.join("-")] : []
                if (matchSkuCode && filterString(matchSkuCode)) arr.push(filterString(matchSkuCode))
                skuCode = arr.join("_")

                // 校验货号是否存在
                // try {
                //     if (!skuCode) throw new Error(`第${row.number}行 序号、主拍品货号、颜色、搭配品货号均为空，请补充后重新上传`)
                // } catch (err) {
                //     // errorList.push(err.message)
                //     continue
                // }

                // 判断imageCount是否能被转为数字，不能则默认1张
                if (isNaN(Number(imageCount))) imageCount = "1"
                imageCount = Math.round(Number(imageCount))

                const uid = Utils.genUid()
                // 先添加sku
                appendSkuCode({
                    uid,
                    index: row.number,
                    id,
                    deliveryVersion,
                    skuCode,
                    imageCount: imageCount,
                })

                // 校验图片大小
                const MAX_IMAGE_SIZE = 50 * 1024 * 1024;

                // 源素材
                for (let skuImageIndex of skuImageIndexs) {
                    try {
                        const text = row.getCell(skuImageIndex.index).text
                        console.log('skuimage', text)
                        if (!text) continue
                        if (text.indexOf('=DISPIMG(') === 0) {
                            const imageId = text.match(/ID_[0-9A-F]{32}/i)[0];
                            if (imageResult[imageId]) {
                                const image = imageResult[imageId]
                                const filename = `${image.name}.${image.extension}`
                                const file = uint8ArrayToFile(image.buffer, filename)
                                // 校验图片大小
                                if (file.size > MAX_IMAGE_SIZE) throw new Error(`第${row.number}行 “${skuImageIndex.value}”图片大小超过${MAX_IMAGE_SIZE / 1024 / 1024}MB，请补充后重新上传`)
                                const url = await Utils.uploadFile(file, true);
                                appendImage({
                                    uid,
                                    index: row.number,
                                    id,
                                    deliveryVersion,
                                    skuCode,
                                    imageCount: imageCount,
                                    name: skuImageIndex.value,
                                    url,
                                    isSkuImages: true,
                                })
                            } else {
                                throw new Error(`第${row.number}行 “${skuImageIndex.value}”图片异常，请补充后重新上传`)
                            }
                        } else {
                            throw new Error(`第${row.number}行 “${skuImageIndex.value}”格式错误，请补充后重新上传`)
                        }
                    } catch (err) {
                        errorList.push(err.message)
                    }
                }
                // 搭配图
                for (let matchImageIndex of matchImageIndexs) {
                    try {
                        const text = row.getCell(matchImageIndex.index).text
                        if (!text) continue
                        if (text.indexOf('=DISPIMG(') === 0) {
                            const imageId = text.match(/ID_[0-9A-F]{32}/i)[0];
                            if (imageResult[imageId]) {
                                const image = imageResult[imageId]
                                const filename = `${image.name}.${image.extension}`
                                const file = uint8ArrayToFile(image.buffer, filename)
                                // 校验图片大小
                                if (file.size > MAX_IMAGE_SIZE) throw new Error(`第${row.number}行 “${matchImageIndex.value}”图片大小超过${MAX_IMAGE_SIZE / 1024 / 1024}MB，请补充后重新上传`)
                                const url = await Utils.uploadFile(file, true);
                                appendImage({
                                    uid,
                                    index: row.number,
                                    id,
                                    deliveryVersion,
                                    skuCode,
                                    imageCount: imageCount,
                                    name: matchImageIndex.value,
                                    url,
                                    isMatchImages: true,
                                })
                            } else {
                                throw new Error(`第${row.number}行 “${matchImageIndex.value}”图片异常，请补充后重新上传`)
                            }
                        } else {
                            throw new Error(`第${row.number}行 “${matchImageIndex.value}”格式错误，请补充后重新上传`)
                        }
                    } catch (err) {
                        errorList.push(err.message)
                    }
                }
                // 参考图
                for (let refImageIndex of refImageIndexs) {
                    try {
                        const text = row.getCell(refImageIndex.index).text
                        if (!text) continue
                        if (text.indexOf('=DISPIMG(') === 0) {
                            const imageId = text.match(/ID_[0-9A-F]{32}/i)[0];
                            if (imageResult[imageId]) {
                                const image = imageResult[imageId]
                                const filename = `${image.name}.${image.extension}`
                                const file = uint8ArrayToFile(image.buffer, filename)
                                // 校验图片大小
                                if (file.size > MAX_IMAGE_SIZE) throw new Error(`第${row.number}行 “${refImageIndex.value}”图片大小超过${MAX_IMAGE_SIZE / 1024 / 1024}MB，请补充后重新上传`)
                                const url = await Utils.uploadFile(file, true);
                                appendImage({
                                    uid,
                                    index: row.number,
                                    id,
                                    deliveryVersion,
                                    skuCode,
                                    imageCount: imageCount,
                                    name: refImageIndex.value,
                                    url,
                                    isRefImages: true,
                                })
                            } else {
                                throw new Error(`第${row.number}行 “${refImageIndex.value}”图片异常，请补充后重新上传`)
                            }
                        } else {
                            throw new Error(`第${row.number}行 “${refImageIndex.value}”格式错误，请补充后重新上传`)
                        }
                    } catch (err) {
                        errorList.push(err.message)
                    }
                }

                // 检查这条sku的源素材是否存在
                // setDataSource(pre => {
                //     const temp = [...pre]
                //     const skuItemIndex = temp.findIndex(item => item.index == row.number)
                //     if (skuItemIndex == -1) return temp
                //     const skuItem = temp[skuItemIndex]
                //     if (skuItem && skuItem.skuImages.length == 0) {
                //         errorList.push(`第${row.number}行 源素材不存在，已删除，请补充后重新上传`)
                //         temp.splice(skuItemIndex, 1)
                //     }
                //     return [...temp]
                // })

                setUploadSuccess(pre => pre+1)
            }

            if (errorList.length > 0) {
                api.warning({
                    message: '已过滤的错误项，请确认：',
                    duration: null,
                    description: (
                        <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
                            <pre style={{
                                whiteSpace: 'pre-wrap',
                                margin: 0,
                                fontFamily: 'inherit'
                            }}>
                                {errorList.map(item => `${item}\n`)}
                            </pre>
                        </div>
                    ),
                })
            }
        } catch (err) {
            console.error(err)
            message.warning(err.message)
        } finally {
            setUploading(false)
        }
    }

    // 开始录入
    const handleSubmit = async () => {
        try {
            setLoading(true)
            // if (!merchantId || !merchantName) {
            //     message.warning("请选择客户名称")
            //     return
            // }
            if (!deliveryVersionRef.current) {
                message.warning("交付批次为空，请重新上传")
                return
            }
            // const skuImagesIsEmpty = displayDataSource.find(item => item.skuImages.length == 0)
            // if (skuImagesIsEmpty) {
            //     message.warning(`第${skuImagesIsEmpty.index}行 请至少上传一张源素材`)
            //     return
            // }
            if (goodsType == GOODS_TYPE.CONSIGNMENT) {
                const skuImagesNotOne = displayDataSource.find(item => item.skuImages.length > 1)
                if (skuImagesNotOne) {
                    const uid = skuImagesNotOne.uid
                    if (uid) {
                        const indexList = dataSource.filter(item => item.uid == uid).map(item => item.index)
                        const msg = indexList.map(index => `第${index}行`).join()
                        message.warning(`${msg} 寄拍商品只能上传一张源素材`)
                        return
                    } else {
                        message.warning(`第${skuImagesNotOne.index}行 寄拍商品只能上传一张源素材`)
                        return
                    }
                }
            }
            const skuList = displayDataSource.map(item => {
                return {
                    skuCode: item.skuCode,
                    deliveryVersion: deliveryVersionRef.current,
                    imageCount: item.imageCount || 1,
                    skuImages: item.skuImages.map((item2, index) => (index == 0 && item.skuCode) ? ({
                        ...item2,
                        name: item.skuCode
                    }) :
                    ({...item2})),
                    matchImages: item.matchImages,
                    refImages: item.refImages
                }
            })
            onOk(skuList)
        } catch (err) {
            console.error(err)
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }
    // 全部清空
    const cleanClick = () => {
        setDataSource([])
        deliveryVersionRef.current = null
    }
    // 删除sku
    const handleRemoveSku = (record) => {
        Modal.confirm({
            title: "确定删除这个sku？",
            onOk: () => setDataSource(pre => {
                const temp = [...pre]
                const res = temp.filter(item => item.uid !== record.uid)
                if (res.length == 0) deliveryVersionRef.current = null
                return res
            })
        })
    }
    // 删除sku的图片
    const handleRemoveImage = (record, type) => {
        setDataSource(pre => {
            const temp = [...pre]
            for (let item of temp) {
                const index = item[type].findIndex(i => i.url == record.url)
                if (index >= 0) item[type].splice(index, 1)
            }
            return temp
        })
    }
    // 移动图片
    const handleDrop = (record, rowId, fromType, toType) => {
        setDataSource(pre => {
            const temp = [...pre]
            for (let item of temp) {
                if (item.uid == rowId) {
                    const fromList = item[fromType]
                    const toList = item[toType]
                    fromList.splice(record.index, 1)
                    toList.push({
                        name: record.name,
                        url: record.url
                    })
                    item[fromType] = fromList
                    item[toType] = toList
                    return temp
                }
            }
            return temp
        })
    }

    const columns = [{
        title: '序号',
        dataIndex: 'id',
        key: 'id',
        width: 100,
    }, {
        title: '货号',
        dataIndex: 'skuCode',
        key: 'skuCode',
        width: 250,
    }, {
        title: '需求张数',
        dataIndex: 'imageCount',
        key: 'imageCount',
        width: 250,
    }, {
        title: '源素材',
        dataIndex: 'skuImages',
        key: 'skuImages',
        minWidth: 200,
        width: 400,
        render: (text, record) => (
            <ImageList rowId={record.uid} type="skuImages" onDrop={handleDrop}>
            {
                text.map((item, index) => (
                    <ImageItem
                        key={item.url}
                        index={index}
                        rowId={record.uid}
                        type="skuImages"
                        url={item.url}
                        name={item.name}
                        displayName={index == 0 ? record.skuCode || item.name : item.name}
                        onRemove={() => handleRemoveImage(item, "skuImages")}
                    />
                ))
            }
            </ImageList>
        )
    }, goodsType == GOODS_TYPE.NON_CONSIGNMENT ? {
        title: '搭配图',
        dataIndex: 'matchImages',
        key: 'matchImages',
        minWidth: 200,
        width: 400,
        render: (text, record) => (
            <ImageList rowId={record.uid} type="matchImages" onDrop={handleDrop}>
            {
                text.map((item, index) => (
                    <ImageItem
                        key={item.url}
                        index={index}
                        rowId={record.uid}
                        type="matchImages"
                        url={item.url}
                        name={item.name}
                        onRemove={() => handleRemoveImage(item, "matchImages")}
                    />
                ))
            }
            </ImageList>
        )
    } : null, {
        title: '参考图',
        dataIndex: 'refImages',
        key: 'refImages',
        minWidth: 200,
        width: 400,
        render: (text, record) => (
            <ImageList rowId={record.uid} type="refImages" onDrop={handleDrop}>
            {
                text.map((item, index) => (
                    <ImageItem
                        key={item.url}
                        index={index}
                        rowId={record.uid}
                        type="refImages"
                        url={item.url}
                        name={item.name}
                        onRemove={() => handleRemoveImage(item, "refImages")}
                    />
                ))
            }
            </ImageList>
        )
    }, {
        key: "acition",
        title: "操作",
        width: 200,
        fixed: 'right',
        render: (_, record) => (
            <Space>
                <Button danger type="link" onClick={() => handleRemoveSku(record)}>删除</Button>
            </Space>
        )
    }].filter(item => !!item)

    return (
        <div className={styles.Contianer}>
            {modalContextHolder}
            {contextHolder}
            <div className={styles.Header}>
                <Space size={8}>
                    <span>上传图片</span>
                    <Upload.Dragger
                        className={styles.UploadBtn}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        listType="picture-card"
                        showUploadList={false}
                        beforeUpload={handleUpload}
                        disabled={uploading}
                    >
                        <Button loading={uploading}>拖拽或点击上传Excel</Button>
                    </Upload.Dragger>
                </Space>
            </div>
            <div className={styles.Body}>
            {
                displayDataSource.length > 0 ?
                <Table
                    className="customTable"
                    rowKey={"index"}
                    dataSource={displayDataSource}
                    columns={columns}
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                        y: `max-content`,
                    }}
                /> : 
                <Upload.Dragger
                    className={styles.UploadCard}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    listType="picture-card"
                    showUploadList={false}
                    beforeUpload={handleUpload}
                    disabled={uploading}
                >
                    <div className={styles.UploadBox}>
                        <p>拖拽或点击上传Excel</p>
                        <a target="_blank" download href={goodsType == GOODS_TYPE.NON_CONSIGNMENT ? encodeURI("/template/批量录入表格模板.xlsx") : encodeURI("/template/批量录入表格模板_寄拍.xlsx")} onClick={e => e.stopPropagation()}>点击下载 批量录入表格模板</a>
                    </div>
                </Upload.Dragger>
            }
                
            </div>
            <div className={styles.Footer}>
                <Button
                    style={{ width: '300px' }}
                    loading={loading}
                    disabled={displayDataSource.length == 0 || uploading}
                    type="primary"
                    onClick={handleSubmit}>
                    开始录入
                </Button>
                <Button
                    type="link"
                    disabled={displayDataSource.length === 0 || uploading}
                    onClick={cleanClick}
                >
                    全部清空
                </Button>
            </div>
            {uploading &&
            <div className={styles.UploadProgress}>
                <Progress percent={uploadProgress} format={() => `${uploadSuccess}/${uploadTotal}`} />
                <Button danger type="primary" onClick={() => uploadAbort.current?.abort()}>停止</Button>
            </div>}
        </div>
    )
}

export default ExcelBatchAdd

/**
 * 获取工作表中有数据的最大行号
 * @param {ExcelJS.Worksheet} worksheet - ExcelJS 工作表对象
 * @returns {number} 最大行号（如果没有数据则返回 0）
 */
function getMaxDataRowNumber(worksheet) {
    if (!worksheet || typeof worksheet.eachRow !== 'function') {
        throw new Error('Invalid worksheet object.');
    }

    let maxRow = 0;

    worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        // 检查该行是否至少有一个单元格有值
        const hasData = row.values.some(cell => {
            // row.values[0] 是 undefined（ExcelJS 行号从 1 开始）
            return cell !== null && cell !== undefined && cell !== '';
        });

        if (hasData) {
            maxRow = rowNumber;
        }
    });

    return maxRow;
}

// 读取excel
function readExcel(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = function(e) {
            const data = new Uint8Array(e.target.result);
            resolve(data)
        };
        reader.readAsArrayBuffer(file);
    })
}
// 使用JSZip解析wps 嵌入式文件
async function parseWPSEmbedMedia(data, workbook) {
    try {
        // wps 嵌入式
        let isWPSEmbed = false;
        const result = {};
        const zip = await JSZip.loadAsync(data);
        const cellimagesRels = zip.files['xl/_rels/cellimages.xml.rels'] || zip.files['/xl/_rels/cellimages.xml.rels'];
        const cellimages = zip.files['xl/cellimages.xml'] || zip.files['/xl/cellimages.xml'];
        if (cellimagesRels && cellimages) {
            const cellimagesRelsData = await parseStringPromise(await cellimagesRels.async('text'));
            const cellimagesData = await parseStringPromise(await cellimages.async('text'));
            const cellimagesNameRidMap = {};
            cellimagesData['etc:cellImages']['etc:cellImage'].forEach((pic) => {
                const rid = pic['xdr:pic'][0]['xdr:blipFill'][0]['a:blip'][0].$['r:embed'];
                const imageId = pic['xdr:pic'][0]['xdr:nvPicPr'][0]['xdr:cNvPr'][0].$.name;
                cellimagesNameRidMap[rid] = imageId;
            });
            for (const relationship of cellimagesRelsData['Relationships']['Relationship']) {
                const data = relationship.$.Target.match(/media\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/)
                if (!data) continue;
                const fullName = data[1];
                const [name, extension] = fullName.split('.');
                result[cellimagesNameRidMap[relationship.$.Id]] = workbook.media.find(v => v.name === name);
                isWPSEmbed = true;
            }
        }
        if (isWPSEmbed) {
            return result;
        } else {
            throw new Error("暂不支持非wps嵌入式图片")
        }
    } catch (err) {
        console.log('err', err)
        throw err
    }
}
function uint8ArrayToFile(buffer, fileName) {
    // 1. 从文件名提取扩展名
    const extension = fileName.split('.').pop().toLowerCase();
    // 2. 创建扩展名到MIME类型的映射
    const mimeTypes = {
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        webp: 'image/webp',
        svg: 'image/svg+xml',
        bmp: 'image/bmp',
        tiff: 'image/tiff',
        ico: 'image/x-icon'
    };
    // 3. 获取MIME类型（默认为通用二进制类型）
    const mimeType = mimeTypes[extension] || 'application/octet-stream';
    // 4. 创建File对象
    const blob = new Blob([buffer], { type: mimeType });
    const file = new File([blob], fileName, { type: mimeType, lastModified: Date.now() });
    return file
}

function ImageList(props) {
    const {
        rowId,
        type,
        onDrop,
        children
    } = props
    const ref = useRef(null)

    const [{hovered}, drop] = useDrop({
        accept: `${rowId}`,
        hover: (item, monitor) => {},
        canDrop: () => false,
        drop: (item, monitor) => {
            if (!monitor.canDrop()) return
            console.log('drop', item)
            const dragType = item.type
            const dropType = type
            if (dragType === dropType) return // 如果回到自己的坑，那就什么都不做
            onDrop(item, rowId, dragType, dropType)
        },
        collect: (monitor) => ({
            hovered: monitor.isOver()
        })
    })

    return (
        <div className={`${styles.ImageList} ${hovered && styles.hovered}`} ref={drop(ref)}>
        {children}
        </div>
    )
}

function ImageItem(props) {
    const {url, name, displayName, index, rowId, type, onRemove} = props

    const ref = useRef(null)
    const [{ isDragging }, drag, preview] = useDrag({
        type: `${rowId}`,
        item: {index, url, name, type},
        canDrag: () => false,
        end: (item, monitor) => {},
        isDragging: (monitor) => index === monitor.getItem().index,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    return (
        <div className={styles.ImageItem} ref={drag(ref)}>
            <Image src={Utils.getImgThumbnail(url)} preview={false} fallback={require('@assets/images/fallback.png')} />
            <span className={styles.ImageName}>{displayName||name}</span>
            <MinusCircleFilled className={styles.RemoveTrigger} onClick={onRemove} />
        </div>
    )
}